<div class="dashboard">
  <h2>统计数据</h2>
  <div class="stats-grid">
    <div class="stat-card">
      <h3>总用户数</h3>
      <div class="stat-value">{{ totalUsers }}</div>
    </div>
    <div class="stat-card">
      <h3>今日活跃</h3>
      <div class="stat-value">{{ activeToday }}</div>
    </div>
    <div class="stat-card">
      <h3>本月新增</h3>
      <div class="stat-value">{{ newThisMonth }}</div>
    </div>
  </div>
</div> 